import { Skeleton } from "@/components/ui/skeleton"
import { cn } from "@/lib/utils" 

interface CardSkeletonProps extends React.HTMLAttributes<HTMLDivElement> {}

export function CardSkeleton({ className, ...props }: CardSkeletonProps) {
  return (
    <Skeleton
      className={cn("rounded-2xl p-5 min-h-[140px]", className)}
      {...props}
    />
  )
}
